<template>
  <div class="news-box">
    <AnimeTitle :title="$t('news.title')" />
    <swiper
      data-animation="fade-scale-up"
      data-once="false"
      :slides-per-view="4.8"
      :space-between="30"
      :allowTouchMove="true"
      ref="newsBoxSwiper"
      @swiper="onSwiper"
      class="news-swiper-box"
      @slideChange="onSlideChange"
    >
      <swiper-slide
        class="news-swiper-item"
        v-for="(item, index) in list"
        :key="index"
        @click="goToDetail(item)"
      >
        <img class="" :src="item.imgUrl" />

        <div class="news-swiper-item_title">{{ item.title }}</div>
        <div class="news-swiper-item_descr">{{ item.content }}</div>
      </swiper-slide></swiper
    >
    <div
      class="news-swiper-pagination"
      data-animation="fade-scale-up"
      data-once="false"
    >
      <img
        :src="lastIcon"
        @click="paginationHandle('last')"
        @mouseenter="handleImageHover($event, nextIcon)"
        @mouseleave="handleImageLeave($event, lastIcon)"
      />

      <img
        class="rigth-icon"
        :src="lastIcon"
        @click="paginationHandle('next')"
        @mouseenter="handleImageHover($event, nextIcon)"
        @mouseleave="handleImageLeave($event, lastIcon)"
      />
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import lastIcon from '@/assets/img/pc/last-icon.png';
import nextIcon from '@/assets/img/pc/next-icon.png';
import { getNewsList } from '@/api/api';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiper: null,
      lastIcon: lastIcon,
      nextIcon: nextIcon,
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    goToDetail(item) {
      window.open(item.newsUrl);
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    onSlideChange() {},
    paginationHandle(type) {
      if (this.swiper) {
        switch (type) {
          case 'last':
            this.swiper.slidePrev();
            break;
          case 'next':
            this.swiper.slideNext();
            break;
        }
      }
    },
    handleImageHover(event, newSrc) {
      const img = event.currentTarget;
      img.src = newSrc;
    },
    handleImageLeave(event, originalSrc) {
      const img = event.currentTarget;
      img.src = originalSrc;
    },
    getList() {
      getNewsList({ pageNum: 1, pageSize: 10 }).then((res) => {
        if (res.responseCode === 200) {
          this.list = res.body.list;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.news-box {
  padding-top: 120px;
  padding-bottom: 60px; /* 为底部阴影留出更多空间 */
  text-align: center;
  overflow: visible;
  .news-swiper-box {
    display: flex;
    // margin-left: 30px;
    margin-top: 40px;
    padding-right: 75px;
    padding-top: 30px; /* 为向上浮动留出空间 */
    padding-bottom: 30px; /* 为底部阴影留出空间 */
    overflow: scroll; /* 改为 visible 确保阴影不被裁剪 */

    /* 隐藏滚动条 */
    &::-webkit-scrollbar {
      display: none;
    }

    /* Firefox */
    scrollbar-width: none;

    /* IE/Edge */
    -ms-overflow-style: none;
    .news-swiper-item {
      width: 360px;
      height: 349px;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #ededed;
      /* 阴影优化 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03), 0 8px 20px rgba(0, 0, 0, 0.02);
      // box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;
      overflow: visible;
      position: relative;
      z-index: 1;
      cursor: pointer;
      margin: 15px 0; /* 为浮动和阴影留出空间 */
      &:first-child {
        margin-left: 30px;
      }
      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.03),
          0 20px 40px rgba(0, 0, 0, 0.02);
        z-index: 10;
      }
      img {
        width: 100%;
        height: 153px;
        object-fit: cover;
        border-radius: 20px 20px 0 0;
      }
      .news-swiper-item_title {
        font-size: 20px;
        color: #222226;
        text-align: left;
        line-height: 27px;
        font-family: 'MiSans-Medium';
        margin: 20px 20px 10px 20px;
        display: -webkit-box; /* 必须和下面两行一起使用 */
        -webkit-line-clamp: 2; /* 显示行数 */
        -webkit-box-orient: vertical;
        overflow: hidden; /* 超出隐藏 */
        text-overflow: ellipsis; /* 超出显示省略号 */
        word-break: break-word;
        /* 可以限制高度精确为两行 */
        // max-height: calc(27px * 2);
      }
      .news-swiper-item_descr {
        font-size: 14px;
        color: #757580;
        line-height: 24px;
        text-align: left;
        margin: 0 20px;
        // max-height: 100px;
        overflow: hidden;
        text-overflow: ellipsis; /* 超出显示省略号 */
        word-break: break-word;
        display: -webkit-box; /* 必须和下面两行一起使用 */
        -webkit-line-clamp: 3; /* 显示行数 */
        -webkit-box-orient: vertical;
      }
    }
  }
  .news-swiper-pagination {
    margin-top: 25px;
    text-align: center;
    img {
      width: 56px;
      height: 56px;
      cursor: pointer;
    }
    img:first-child {
      margin-right: 20px;
      &:hover {
        transform: rotate(180deg);
      }
    }
    .rigth-icon {
      transform: rotate(180deg);
      &:hover {
        transform: rotate(0deg);
      }
    }
  }
}
</style>
